<template>
	<ui-card
		icon="fal fa-cogs"
		title="Gerar contratos"
		text="Configurações de grupos de usuários que podem gerar contratos."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<div class="internal-header">
					<h2 class="title">Grupos que podem gerar contratos</h2>
					<span class="desc"
						>Os grupos configurados abaixo poderão realizar todas as ações relacionadas ao Contrato na interna do negócio.</span
					>
				</div>

				<ui-select-2
					v-model="form.contractSettings"
					:data="userGroups"
					:search="false"
					item-label="label"
					return-value="value"
					group-by="group"
					multiple
				/>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { user } from '@/services/axios'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { defaultOptionsUserGroups } from '../../util/functions'

	const userGroups = ['admin', 'collaborator', 'supervisor', 'manager', 'broker']

	const defaultForm = () => ({
		contractSettings: []
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-users-general',

		components: {
			uiCard,
			uiButton,
			uiLoadSuccess,
			uiLoadIndicator,
			uiSelect2
		},

		mixins: [utilMixin, formMixin, alertMixin],

		async created() {
			this.loader.body = true

			const [contractSettings, userGroups] = await Promise.all([
				this.getConfig('contractSettings', 'value_long'),
				user.groups()
			])

			userGroups.data.forEach(group => {
				this.userGroups.push({
					id: group.id,
					value: group.name,
					label: group.name,
					group: 'Perfis Dinâmicos'
				})
			})

			this.form.contractSettings = contractSettings.allowedGroups

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				oldForm: {},
				userGroups: [...defaultOptionsUserGroups(userGroups)],
			}
		},

		computed: {
			canSubmit() {
				return (
					this.$mx_isFormChanged &&
					!this.loader.body
				)
			},

			brokerApproveValue() {
				return this.form.brokerApprove ? 'active' : 'inactive'
			},
		},

		methods: {
			getConfig,
			saveConfig,

			stringToBoolean(string) {
				return string == 'true'
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await Promise.all([
						this.saveConfig('contractSettings', { allowedGroups: this.form.contractSettings }, 'value_long')
					])

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
